import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-37c4e4db"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "home-feature-cards",
  "aria-labelledby": "home-feature-title"
};
const _hoisted_2 = {
  id: "home-feature-title",
  class: "sr-only"
};
const _hoisted_3 = {
  class: "feature-grid"
};
const _hoisted_4 = {
  class: "feature-copy"
};
const _hoisted_5 = {
  class: "feature-art",
  "aria-hidden": "true"
};
const _hoisted_6 = ["src", "alt"];
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import tradeImage from '@/assets/home1/feature-trade.png';
import earnImage from '@/assets/home1/feature-earn.png';
import playImage from '@/assets/home1/feature-play.png';
import buildImage from '@/assets/home1/feature-build.png';
import secureImage from '@/assets/home1/feature-secure.png';
export default {
  __name: 'HomeFeatureCards',
  setup(__props) {
    const {
      t
    } = useI18n();
    const features = computed(() => [{
      id: 'trade',
      title: t('homepage.features.trade.title'),
      description: t('homepage.features.trade.description'),
      image: tradeImage
    }, {
      id: 'earn',
      title: t('homepage.features.earn.title'),
      description: t('homepage.features.earn.description'),
      image: earnImage
    }, {
      id: 'play',
      title: t('homepage.features.play.title'),
      description: t('homepage.features.play.description'),
      image: playImage
    }, {
      id: 'build',
      title: t('homepage.features.build.title'),
      description: t('homepage.features.build.description'),
      image: buildImage
    }, {
      id: 'secure',
      title: t('homepage.features.secure.title'),
      description: t('homepage.features.secure.description'),
      image: secureImage
    }]);
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("section", _hoisted_1, [_createElementVNode("h2", _hoisted_2, _toDisplayString(_unref(t)('homepage.features.sectionTitle')), 1), _createElementVNode("div", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(features), (feature, index) => {
        return _openBlock(), _createElementBlock("article", {
          key: feature.id,
          class: _normalizeClass(["feature-card", `feature-card--${feature.id}`]),
          style: _normalizeStyle({
            '--feature-index': index
          })
        }, [_createElementVNode("div", _hoisted_4, [_createElementVNode("h3", null, _toDisplayString(feature.title), 1), _createElementVNode("p", null, _toDisplayString(feature.description), 1)]), _createElementVNode("div", _hoisted_5, [_createElementVNode("img", {
          src: feature.image,
          alt: feature.title
        }, null, 8, _hoisted_6)])], 6);
      }), 128))])]);
    };
  }
};